import script from "./BasicInformationUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasicInformationUser.vue?vue&type=script&lang=ts&setup=true"

import "./BasicInformationUser.vue?vue&type=style&index=0&id=4fd0e8d5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd0e8d5"]])

export default __exports__